import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getStatusByScope } from '../../store/Project/projectSlice';
import { useTranslation } from 'react-i18next';

const useGetStatusList = () => {
  const dispatch = useAppDispatch();

  const { i18n, t } = useTranslation();
  const { StatusList, loading3, error3 } = useAppSelector(state => state.ProjectDetails);

  useEffect(() => {
    // if (StatusList?.length === 0) {
    dispatch(getStatusByScope());
    // }
  }, []);

  const PROJECT_Status = StatusList.filter(f => f.scope === 'PROJECT')?.map(item => ({
    value: item.code,
    label: i18n.language === 'en' ? item.name : item.name2
  }));
  const BUDGET_Status = StatusList.filter(f => f.scope === 'BUDGET')?.map(item => ({
    id: item.id,
    value: item.code,
    label: i18n.language === 'en' ? item.name : item.name2
  }));
  const CONTRACT_Status = StatusList.filter(f => f.scope === 'CONTRACT')?.map(item => ({
    id: item.id,
    value: item.code,
    label: i18n.language === 'en' ? item.name : item.name2
  }));
  const INCIDENT_CR_Status = StatusList.filter(f => f.scope === 'INCIDENT-CR')?.map(item => ({
    value: item.code,
    label: i18n.language === 'en' ? item.name : item.name2
  }));
  const INCIDENT_ISSUE_Status = StatusList.filter(f => f.scope === 'INCIDENT-ISSUE')?.map(item => ({
    value: item.code,
    label: i18n.language === 'en' ? item.name : item.name2
  }));
  const INCIDENT_RISK_Status = StatusList.filter(f => f.scope === 'INCIDENT-RISK')?.map(item => ({
    value: item.code,
    label: i18n.language === 'en' ? item.name : item.name2
  }));

  return {
    StatusList,
    PROJECT_Status,
    BUDGET_Status,
    CONTRACT_Status,
    INCIDENT_CR_Status,
    INCIDENT_ISSUE_Status,
    INCIDENT_RISK_Status,
    loading: loading3,
    error: error3
  };
};

export default useGetStatusList;

// import { useEffect, useMemo } from 'react';
// import { useAppDispatch, useAppSelector } from '../../store/hooks';
// import { getStatusByScope } from '../../store/Project/projectSlice';
// import { useTranslation } from 'react-i18next';

// // Define types for better TypeScript support
// interface StatusItem {
//   code: string;
//   name: string;
//   name2: string;
// }

// interface StatusOption {
//   value: string;
//   label: string;
// }

// // Cache status types to avoid recreating arrays
// const STATUS_TYPES = ['PROJECT', 'BUDGET', 'CONTRACT', 'INCIDENT-CR', 'INCIDENT-ISSUE', 'INCIDENT-RISK'] as const;

// const useGetStatusList = () => {
//   const dispatch = useAppDispatch();
//   const { i18n } = useTranslation();
//   const { StatusList, loading3, error3 } = useAppSelector(state => state.ProjectDetails);

//   // Fetch status list only if empty
//   useEffect(() => {
//     if (!StatusList?.length) {
//       dispatch(getStatusByScope());
//     }
//   }, [StatusList?.length, dispatch]);

//   // Memoize the status mapping logic
//   const statusMappings = useMemo(() => {
//     const getStatusOptions = (code: string): StatusOption[] =>
//       StatusList?.filter((item: StatusItem) => item.code === code)?.map((item: StatusItem) => ({
//         value: item.code,
//         label: i18n.language === 'en' ? item.name : item.name2
//       })) || [];

//     return {
//       PROJECT_Status: getStatusOptions('PROJECT'),
//       BUDGET_Status: getStatusOptions('BUDGET'),
//       CONTRACT_Status: getStatusOptions('CONTRACT'),
//       INCIDENT_CR_Status: getStatusOptions('INCIDENT-CR'),
//       INCIDENT_ISSUE_Status: getStatusOptions('INCIDENT-ISSUE'),
//       INCIDENT_RISK_Status: getStatusOptions('INCIDENT-RISK'),
//       StatusList,
//       loading: loading3,
//       error: error3
//     };
//   }, [StatusList, i18n.language, loading3, error3]);

//   return statusMappings;
// };

// export default useGetStatusList;
